export function trim(str) {
  return String.prototype.trim.call(str);
}

export function isType(arg, type) {
  return Object.prototype.toString.call(arg) === "[object " + type + "]";
}

export function isWeixin() {
  // return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;
}

export function parseQuery() {
  const res = {};

  const query = (location.href.split("?")[1] || "")
    .trim()
    .replace(/^(\?|#|&)/, "");

  if (!query) {
    return res;
  }

  query.split("&").forEach(param => {
    const parts = param.replace(/\+/g, " ").split("=");
    const key = decodeURIComponent(parts.shift());
    const val = parts.length > 0 ? decodeURIComponent(parts.join("=")) : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res;
}
// console.log(' process.env.VUE_APP_API_URL', process.env.VUE_APP_API_URL)
// const VUE_APP_API_URL = 'https://crshop.chengguokeji.net/api' || `${location.origin}/api`;
// const VUE_APP_API_URL = "https://manage.im2015.com/api" || `${location.origin}/api`;
// // const VUE_APP_WS_URL =  'https://crshop.chengguokeji.net/api' || `ws:${location.hostname}:20003`;
// const VUE_APP_WS_URL =
//   "https://manage.im2015.com/api" || `ws:${location.hostname}:20003`;
const VUE_APP_API_URL=process.env.VUE_APP_API_URL|| `${location.origin}/api`;
const VUE_APP_WS_URL=process.env.VUE_APP_WS_URL || `ws:${location.hostname}:20003`;
export function getUrlKey(name, url) {
  return (
    decodeURIComponent(
      (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(url) || [
        ,
        ""
      ])[1].replace(/\+/g, "%20")
    ) || null
  );
}
export { VUE_APP_API_URL, VUE_APP_WS_URL };
